import { lexonHttp } from "@/plugins/axios/lexonHttp"

export class ActionsService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }

  postData(url: string, data: string) {
    const params = new URLSearchParams()
    params.append('json', data)
    return lexonHttp.post(url, params)
  }
}
